import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link2 as Icon } from 'react-feather';
import { Colors, Tooltip, Message } from 'app/seedly-component-library';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';
import useIsMobile from 'app/utils/hooks/useIsMobile';
import { useAmp } from 'next/amp';
import buildCopyLinkHtmlString from './buildCopyLinkHtmlString';

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  svg {
    transform: rotate(45deg);
    :hover {
      stroke: ${props => props.theme.colors.seedlyBlue};
    }
  }
`;

const Svg = styled.svg`
  transform: rotate(45deg);
  &:hover {
    stroke: ${props => props.theme.colors.seedlyBlue};
  }
`;

const handleOnCopy = () => {
  Message.success('Link Copied');
};

const LinkIcon = () => (
  <Svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="23"
    height="23"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#40485a"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </Svg>
);

const Button = ({ size, url }) => {
  const isAmp = useAmp();

  // Selectors
  const isMobile = useIsMobile();

  if (isMobile) {
    if (isAmp) {
      return (
        <amp-iframe
          sandbox="allow-scripts"
          width="64"
          height="22"
          frameborder="0"
          srcdoc={buildCopyLinkHtmlString(url)}
        >
          <amp-img
            width="22px"
            height="22px"
            style={{ margin: '0 16px' }}
            src="/"
            placeholder
          >
            <LinkIcon width={`${size}px`} />
          </amp-img>
        </amp-iframe>
      );
    }

    return (
      <CopyToClipboard text={url} onCopy={handleOnCopy}>
        <Wrapper>
          <Icon size={size || '24'} color={Colors.neutral7} />
        </Wrapper>
      </CopyToClipboard>
    );
  }

  return (
    <Tooltip
      showToolTip={!isMobile}
      placement="top"
      renderTriggerButton={() => {
        return (
          <CopyToClipboard text={url} onCopy={handleOnCopy}>
            <Wrapper>
              <Icon size={size || '24'} color={Colors.neutral7} />
            </Wrapper>
          </CopyToClipboard>
        );
      }}
      renderToolTipBody={() => (
        <div style={{ width: '150px', flexWrap: 'wrap' }}>Copy Link</div>
      )}
    />
  );
};

const CopyLinkButton = ({ size, url }) => {
  return (
    <div
      onClick={() => {
        mixpanel.track(trackedEvents.ShareBar, {
          param: 'copy_link',
        });
      }}
      id="copy-link-button"
    >
      <Button size={size} url={url} />
    </div>
  );
};
CopyLinkButton.propTypes = {
  size: PropTypes.string,
  url: PropTypes.string.isRequired,
};

CopyLinkButton.defaultProps = {
  size: '24',
};

export default CopyLinkButton;
